<template>
	<div class="dt-companies-card flex w-full flex-row items-start overflow-hidden rounded border border-solid border-whisper bg-white">
		<Link :href="route('company-team', row.slug)" class="dt-companies-card-image">
			<img class="block w-auto max-w-full" :src="row.image_url" alt="Company Image" />
		</Link>
		<Link :href="route('company-team', row.slug)" class="dt-companies-card-content flex flex-col">
			<div class="dt-companies-card-content-name">
				<span class="block w-full truncate">{{ row.name }}</span>
			</div>
			<div class="dt-companies-card-content-industries">
				<span class="block w-full truncate">
					{{ row.industries.length > 1 ? `${row.industries.length} Industries` : row.industries.map((industry) => industry.name).join(", ") }}
				</span>
			</div>
			<div class="dt-companies-card-content-location">{{ row.country_name }}</div>
			<div class="dt-companies-card-content-company-size">{{ row.company_size }}</div>
		</Link>
	</div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
	row: {
		type: Object,
		required: true,
	},
});
</script>
